import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute, DomainRedirect } from '../utils/domain/routingComponents'
import {
  legacyOrdersDeliveryAccessControl,
  legacyOrdersPickupAccessControl,
} from '../access-control/legacyOrdersAccess.configuration'
import { scanAndPayAccessControl } from '../access-control/scanAndPayAccess.configuration'

const LegacyOrdersList = lazy(
  () =>
    import(
      /* webpackChunkName: "LegacyOrdersList" */
      '../pages/orders-list/LegacyOrdersListPage'
    )
)

const LegacyOrderDetailsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LegacyOrderDetailsPage" */
      '../pages/order-details/LegacyOrderDetailsPage'
    )
)
// @hygen:inject page-import

/**
 * Legacy Orders Router
 *
 * Routes for the legacy orders functionality.
 */
export const legacyOrdersRouter = (
  <DomainRoute route="legacy-orders">
    <DashSwitch>
      <DomainRoute
        exact
        route="legacy-orders-delivery"
        accessControl={legacyOrdersDeliveryAccessControl}
        component={() => <LegacyOrdersList orderType="delivery" />}
      />
      <DomainRoute
        exact
        route="legacy-orders-pickup"
        accessControl={legacyOrdersPickupAccessControl}
        component={() => <LegacyOrdersList orderType="pickup" />}
      />
      <DomainRoute
        exact
        route="legacy-orders-scan-and-pay"
        accessControl={scanAndPayAccessControl}
        component={() => <LegacyOrdersList orderType="scan_and_pay" />}
      />
      <DomainRoute route="legacy-orders-order-details" component={LegacyOrderDetailsPage} />
      <DomainRedirect to="legacy-orders-delivery" />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
